// extracted by mini-css-extract-plugin
export default {"hooksMain":"styles2_hooksMain__-t0ai"};